// src/v2/components/modules/UploadingSchedule/components/UploadingScheduleLegend.js
import React from "react";
import { formatTime } from "../../../../../utils/textUtils";
import { FEATURES } from "../../../../../config/features";

const UploadingScheduleLegend = ({ data, allShifts }) => {
  if (data.length === 0) return null;

  return (
    <div className="p-4 bg-white rounded-lg border border-gray-200 shadow-sm">
      <h4 className="text-[11px] font-bold text-gray-500 uppercase mb-3 flex items-center gap-2">
        <div className="h-2 w-2 bg-blue-500 rounded-full"></div>
        Shift Schedule Reference
      </h4>
      <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-3">
        {allShifts.map(s => (
          <div key={s.id} className="flex flex-col p-2 bg-gray-50 rounded border border-gray-100">
            {/* MODIFIED: Primary label toggles between Code and Name */}
            <span className="text-blue-700 font-black text-xs truncate" title={s.shiftName}>
              {FEATURES.SHIFTSCHEDULE_CODE ? s.code : s.shiftName}
            </span>

            {/* MODIFIED: Only show the ShiftName here if the Code is being used as primary */}
            {FEATURES.SHIFTSCHEDULE_CODE && (
              <span className="text-[10px] text-gray-500 truncate" title={s.shiftName}>
                {s.shiftName}
              </span>
            )}

            <span className="text-[9px] text-gray-400">
              {formatTime(s.timeFrom)} - {formatTime(s.timeTo)}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default UploadingScheduleLegend;